<template>
  <div>
    <b-card no-body>
      <b-tabs card v-model="tabIndex">
        <b-tab>
          <template slot="title">
            <tab-item icon="users" heading="Step 1" subheading="Details" :error="errorDetails"></tab-item>
          </template>
          <div class="form-panel">
            <form-details :categories="categories"
                          :types="types"
                          :terms="terms"
                          :dirty="dirty"
                          :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template>              
            </form-details>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="file-alt" heading="Step 2" subheading="Description"></tab-item>
          </template>
          <div class="form-panel">
            <form-description :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template> 
            </form-description>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="table" heading="Step 3" subheading="Courses"></tab-item>
          </template>
          <div class="form-panel">
            <form-internship :academicPlans="academicPlans" :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template> 
            </form-internship>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="table" heading="Step 4" subheading="Areas of Interest"></tab-item>
          </template>
          <div class="form-panel">
            <form-interest :categories="areaOfInterestCategories" :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template> 
            </form-interest>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="list" heading="Step 5" subheading="Additional Materials"></tab-item>
          </template>
          <div class="form-panel">
            <form-materials :additionalMaterials="additionalMaterials" :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template> 
            </form-materials>
          </div>
        </b-tab>
        <b-tab v-if="!isTranslationalTeam">
          <template slot="title">
            <tab-item icon="users" heading="Step 6" subheading="How to Apply" :error="errorApply"></tab-item>
          </template>
          <div class="form-panel">
            <form-apply :dirty="dirty" :applicationTypes="applicationTypes" :opportunity="opportunity">
              <template slot="buttons">
                <b-button class="btn-primary pull-right save-opportunity-button" @click="save">{{ buttonLabel }}</b-button>
              </template> 
            </form-apply>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-alert variant="danger" :show="errorDetails || errorApply">
      <span v-if="errorDetails && !errorApply">There is an error on step 1. Please fix before proceeding.</span>
      <span v-if="errorApply && !errorDetails">There is an error on step 6. Please fix before proceeding.</span>
      <span v-if="errorApply && errorDetails">There are errors on steps 1 and 6. Please fix before proceeding.</span>
    </b-alert>
  </div>
</template>

<script>
import TabItem from "../menu/tab-item";
import FormDetails from "./form/form-details";
import FormDescription from "./form/form-description";
import FormInternship from "./form/form-internship";
import FormInterest from "./form/form-interest";
import FormMaterials from "./form/form-materials";
import FormApply from "./form/form-apply";

export default {
  data() {
    return {
      tabIndex: 0
    };
  },

  props: {
    categories: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    },
    terms: {
      type: Array,
      required: true
    },
    academicPlans: {
      type: Array,
      required: true
    },
    areaOfInterestCategories: {
      type: Array,
      required: true
    },
    additionalMaterials: {
      type: Array,
      required: true
    },
    applicationTypes: {
      type: Array,
      required: true
    },
    dirty: {
      type: Boolean
    },
    opportunity: {
      type: Object
    },
    step: {
      required: false,
      type: Number,
      default: 0
    }
  },

  components: {
    "tab-item": TabItem,
    "form-details": FormDetails,
    "form-description": FormDescription,
    "form-internship": FormInternship,
    "form-interest": FormInterest,
    "form-materials": FormMaterials,
    "form-apply": FormApply
  },

  computed: {
    errorDetails: function() {
      return !this.$store.state.opportunityForm.validationStates.details;
    },

    errorApply: function() {
      return !this.$store.state.opportunityForm.validationStates.apply;
    },

    opportunityType: function() {
      return this.$store.state.opportunityForm.opportunityType;
    },
    isTranslationalTeam() {
      return (
        this.opportunityType &&
        this.opportunityType.name == "Translational Team"
      );
    },
    totalTabs() {
      if (this.isTranslationalTeam) {
        return 4;
      } else {
        return 5;
      }
    },
    buttonLabel() {
      if (this.tabIndex == this.totalTabs) {
        return "Save";
      } else {
        return "Save and Next";
      }
    }
  },

  methods: {
    save() {
      this.$emit("save", this.tabIndex);
    }
  },

  watch: {
    step: function() {
      this.tabIndex = this.step;
    }
  },

  created() {
    if (this.step) {
      this.tabIndex = this.step;
    }
  }
};
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
</style>
